import {
  convertMagnifiedToDecimal,
  STOCK_UI,
} from '@diamond/shared/decimal-util-web';
import { numberWithSeparator } from '@diamond/shared/utils';

import { OrderItemQuantityMeta, ReasonAlertItem } from './types';

/**
 * Groups items by their cancellation/rejection reason
 * Used for displaying "Salah pesan" error boxes
 */
export function groupItemsByReason(
  items: ReasonAlertItem[],
  reasons: (string | null)[]
): Map<string, ReasonAlertItem[]> {
  const grouped = new Map<string, ReasonAlertItem[]>();

  items.forEach((item, index) => {
    const reason = reasons[index] || 'Dibatalkan';
    const existing = grouped.get(reason) || [];
    grouped.set(reason, [...existing, item]);
  });

  return grouped;
}

export function formatOrderItemQuantity(
  value: number,
  meta?: OrderItemQuantityMeta
): string {
  const normalized = meta?.stock_magnifier
    ? value / meta.stock_magnifier
    : convertMagnifiedToDecimal(value, STOCK_UI);
  return numberWithSeparator(normalized);
}

export function resolveOrderItemUnit(
  meta: OrderItemQuantityMeta | undefined,
  fallbackUnit?: string
): string {
  return (
    meta?.measurement_unit_desc ||
    meta?.measurement_unit ||
    fallbackUnit ||
    'item'
  );
}
